import { FC } from 'react';

import { Gemstones } from 'components/Sections/HoroscopesSignsAllAboutSigns/Gemstones';
import { ZodiacSignFeatureSingleElementInterface } from 'types/componentTypes';
import { useDeviceHoroscopeInfo } from 'lib/horoscope/horoscope.hook';

const GemstonesContainer: FC<ZodiacSignFeatureSingleElementInterface> = ({
  element,
}) => {
  const {
    mobileViewMaxWidth,
    horoscopeTabletMaxWidth,
    viewerDevice,
  } = useDeviceHoroscopeInfo();

  return (
    <Gemstones
      gemstones={element}
      viewerDevice={viewerDevice}
      mobileViewMaxWidth={mobileViewMaxWidth}
      horoscopeTabletMaxWidth={horoscopeTabletMaxWidth}
    />
  );
};

export default GemstonesContainer;
